export const statusMap = {
  PENDING: { label: "Aguardando", color: "warning" },
  RUNNING: { label: "Executando", color: "info" },
  SUCCESS: { label: "Sucesso", color: "success" },
  FAILED: { label: "Falha", color: "danger" },
}

export const statusOptions = [
  { label: "Aguardando", value: "PENDING" },
  { label: "Executando", value: "RUNNING" },
  { label: "Sucesso", value: "SUCCESS" },
  { label: "Falha", value: "FAILED" },
]
